<template>
  <img
    class="word-icon"
    src="../assets/img/word_dwn_lrg.png"
    alt="Word Icon"
    style="padding-top: 4px"
  />
</template>
